export const PdfPrintAction = "pdf.print";
